//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'NumberInputSpinner',

  data: function () {
    return {
      numericValue: this.value,
      timer: null,
    }
  },

  props: {
    value: {
      type: [Number, Object,String],
      default: 0,
    },
    min: {
      default: 0,
      type: [Number, Object,String],
    },
    max: {
      default: 10,
      type: [Number, Object,String],
    },
    step: {
      default: 1,
      type: Number,
    },
    mouseDownSpeed: {
      default: 100,
      type: Number,
    },
    inputClass: {
      default: 'vnis__input',
      type: String,
    },
    buttonClass: {
      default: 'vnis__button',
      type: String,
    },
    integerOnly: {
      default: false,
      type: Boolean,
    },
  },

  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    blurInput(){
      this.$emit('blur')
    },
    whileMouseDown(callback) {
      if (this.timer === null) {
        this.timer = setInterval(() => {
          callback()
        }, this.mouseDownSpeed)
      }
    },

    increaseNumber() {
      this.numericValue += this.step
    },

    decreaseNumber() {
      this.numericValue -= this.step
    },

    isInteger(evt) {
      evt = evt ? evt : window.event
      let key = evt.keyCode || evt.which
      key = String.fromCharCode(key)
      const regex = /[0-9]/

      if (!regex.test(key)) {
        evt.returnValue = false
        if (evt.preventDefault) evt.preventDefault()
      }
    },

    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    validateInput(evt) {
      if (this.integerOnly === true) {
        this.isInteger(evt)
      } else {
        this.isNumber(evt)
      }
    },

    inputValue(evt) {
      this.numericValue = evt.target.value
        ? parseInt(evt.target.value)
        : this.min
    },
  },

  watch: {
    value: function (val, oldVal) {
      if (val != oldVal) {
        this.numericValue = val
      }
    },
    numericValue: function (val, oldVal) {
      if (val <= this.min) {
        this.numericValue = parseInt(this.min)
      }

      if (val >= this.max) {
        this.numericValue = parseInt(this.max)
      }

      if (val <= this.max && val >= this.min) {
        this.$emit('input', val, oldVal)
      }
    },
  },
}
